import * as constants from './constants';

export const getProjects = (payload) => ({ type: constants.GET_PROJECTS, payload });
export const getProjectsSuccess = (payload) => ({ type: constants.GET_PROJECTS_SUCCESS, payload });
export const getProjectsError = (payload) => ({ type: constants.GET_PROJECTS_ERROR, payload });

export const clearProjects = () => ({ type: constants.CLEAR_PROJECTS });
